// All case studies / projects.
// Jugni Lifestyle has been moved to the LAST position as requested.
export const projects = [
  {
    slug: "sanatan-after-school",
    name: "Sanatan After School",
    category: "Education",
    tags: ["Platform", "Meta Ads"],
    accent: "#00e5ff",
    meta: "Platform build / search growth / paid amplification",
    outcome: "Boot camp demand kept climbing",
    summary:
      "Built from scratch — sharpened the information architecture and helped the program become easier to discover and easier to trust.",
    details: ["Enrollment pages", "Search lift", "Meta campaigns"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "An education platform built from the ground up — designed to make the program easier to discover, easier to understand, and easier to trust.",
      challenge:
        "The program had real depth but no digital home. Parents and students discovered it through word of mouth, then bounced when they couldn't find clear information online.",
      approach:
        "We rebuilt the information architecture, designed enrollment-first pages, and ran search-aligned content alongside Meta campaigns to bring qualified traffic to the right pages.",
      results: [
        { metric: "Steady demand", desc: "Boot camp enrollments climbed month over month" },
        { metric: "Cleaner journeys", desc: "Parents could find what they needed in fewer clicks" },
        { metric: "Search lift", desc: "Organic visibility for program-specific queries" },
      ],
      services: ["Platform build", "Information architecture", "Meta Ads", "SEO foundation"],
    },
  },
  {
    slug: "conscious-yatri",
    name: "Conscious Yatri",
    category: "Community",
    tags: ["Platform", "Web"],
    accent: "#ff5ec4",
    meta: "Community platform / product story / member experience",
    outcome: "A clearer home for an active community",
    summary:
      "A community-driven platform for conscious travellers — designed to feel warm, social, and clear even as the product story gets layered.",
    details: ["Platform UX", "Member pathways", "Community trust"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A platform for a growing community of conscious travellers — designed to feel social, useful, and unmistakably theirs.",
      challenge:
        "The community had life and momentum, but their digital home didn't reflect either. The product was layered; the site needed to hold all of it without feeling cluttered.",
      approach:
        "We built clear member pathways, simplified the product story across pages, and shaped a tone that matched the warmth of the community itself.",
      results: [
        { metric: "Clarity", desc: "A clearer home for an active community" },
        { metric: "Member pathways", desc: "Easier to onboard, easier to belong" },
        { metric: "Story scale", desc: "Room to grow as the product evolves" },
      ],
      services: ["Platform UX", "Product narrative", "Web build"],
    },
  },
  {
    slug: "spiritual-tribe",
    name: "Spiritual Tribe",
    category: "Community",
    tags: ["SEO", "Content"],
    accent: "#a78bfa",
    meta: "Positioning / content engine / search-led growth",
    outcome: "Organic traffic kept compounding",
    summary:
      "Built a content and positioning system that kept organic traffic growing month after month — no dependence on paid acquisition.",
    details: ["Organic strategy", "Content system", "Authority growth"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A community brand that grew through depth, not ad spend — powered by an organic content engine.",
      challenge:
        "Authentic communities are hard to scale through paid channels — the message gets thin. The brand needed reach that felt earned, not bought.",
      approach:
        "We built a positioning framework, mapped out a content engine around real questions people were searching for, and stayed disciplined about authority over volume.",
      results: [
        { metric: "Compounding traffic", desc: "Organic growth month over month, no paid lift" },
        { metric: "Authority", desc: "Recognised on the queries that matter" },
        { metric: "Content system", desc: "A repeatable engine the team can run" },
      ],
      services: ["Positioning", "SEO", "Content strategy"],
    },
  },
  {
    slug: "insurance-buddys",
    name: "Insurance Buddys",
    category: "Finance",
    tags: ["Lead Gen", "Web"],
    accent: "#00e5ff",
    meta: "Lead-gen site / trust cues / enquiry flow",
    outcome: "Qualified enquiries within the first quarter",
    summary:
      "From almost no digital presence to a practical lead-generation setup — built to attract and convert qualified enquiries.",
    details: ["Lead pages", "Clear offer", "Faster conversion"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A practical lead-generation site for an insurance advisory — built around trust, clarity, and quick enquiry flows.",
      challenge:
        "The advisory was running on referrals alone. Without a digital footprint, every new enquiry depended on someone remembering them.",
      approach:
        "We built focused lead pages around their strongest offers, layered in trust cues, and tightened the enquiry flow so prospects could reach them in one or two clicks.",
      results: [
        { metric: "Qualified enquiries", desc: "Within the first quarter of launch" },
        { metric: "Faster conversion", desc: "Cleaner enquiry path, less friction" },
        { metric: "Real presence", desc: "Discoverable beyond word of mouth" },
      ],
      services: ["Web", "Landing pages", "Conversion design"],
    },
  },
  {
    slug: "maitri-wellness",
    name: "Maitri Wellness",
    category: "Wellness",
    tags: ["Health", "Web"],
    accent: "#00ffc8",
    meta: "Service design / booking clarity / nurturing tone",
    outcome: "Better clarity across services and bookings",
    summary:
      "A soft, reassuring digital home for expectant mothers — with clear care paths, easy discovery, and booking flows that feel natural.",
    details: ["Gentle UX", "Service pathways", "Booking journeys"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A reassuring digital home for expectant mothers — built around gentle UX, clear care paths, and natural booking flows.",
      challenge:
        "Care for expectant mothers is deeply personal. The site had to feel calm and trustworthy from the very first scroll, while still being clear about what was on offer.",
      approach:
        "We designed the site around tone first — soft, reassuring, never clinical — then layered in service architecture and booking flows that respected the user's pace.",
      results: [
        { metric: "Service clarity", desc: "Each care path is easier to understand and choose" },
        { metric: "Natural bookings", desc: "Booking journeys that don't feel transactional" },
        { metric: "Right tone", desc: "A digital home that matches the in-person warmth" },
      ],
      services: ["Service design", "Web build", "Booking UX", "Copywriting"],
    },
  },
  {
    slug: "natures-nest-goa",
    name: "Nature's Nest Goa",
    category: "Hospitality",
    tags: ["Web", "Ongoing"],
    accent: "#00ffc8",
    meta: "Hospitality storytelling / event pages / destination UX",
    outcome: "Experiences made easier to explore online",
    summary:
      "An ongoing hospitality build for an eco-resort — bringing night safaris, wildlife experiences, and event storytelling into one cohesive presence.",
    details: ["Experience pages", "Destination story", "Ongoing build"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "An ongoing hospitality build for an eco-resort in Goa — weaving night safaris, wildlife experiences, and event storytelling into one digital home.",
      challenge:
        "The property has layers — stay, safari, retreats, events. Every layer deserved its own clarity online, without losing the cohesive sense of place.",
      approach:
        "We've been building this site in chapters — experience pages, retreat templates, structured data, scroll-led storytelling — designed to grow as the property does.",
      results: [
        { metric: "Easier to explore", desc: "Guests can discover experiences before they arrive" },
        { metric: "Cohesive presence", desc: "All offerings live under one digital roof" },
        { metric: "Built to grow", desc: "An ongoing build that scales with the property" },
      ],
      services: ["Web", "Hospitality storytelling", "SEO", "Ongoing partnership"],
    },
  },
  {
    slug: "skatesafe",
    name: "SkateSafe",
    category: "Sports",
    tags: ["Meta Ads", "Marketing"],
    accent: "#ff5ec4",
    meta: "Performance campaigns / landing pages / audience fit",
    outcome: "3.2x traffic growth",
    summary:
      "Took visibility from near-zero to a real market presence through sharper messaging, better landing experiences, and focused campaign loops.",
    details: ["Audience clarity", "Ad system", "Traffic growth"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A safety-first sports brand scaled from near-zero visibility into a real market presence through paid performance and message-first landing pages.",
      challenge:
        "The product solved a real problem, but the audience didn't know it existed. Paid spend without sharp messaging would have burnt cash.",
      approach:
        "We tightened audience definitions, rebuilt landing pages around the single strongest message, and ran focused campaign loops with clear creative discipline.",
      results: [
        { metric: "3.2x traffic", desc: "Compared to pre-campaign baseline" },
        { metric: "Sharper messaging", desc: "Audience clarity led to creative clarity" },
        { metric: "Repeatable system", desc: "An ad system the brand can keep running" },
      ],
      services: ["Meta Ads", "Landing pages", "Creative direction", "Performance marketing"],
    },
  },
  {
    slug: "ai-image-studio",
    name: "Jugni Product Image Studio",
    category: "Internal Tool",
    tags: ["AI Tool", "Internal Tool", "Gemini API"],
    accent: "#00e5ff",
    meta: "AI image generation / Gemini API / internal tooling",
    outcome: "Asset production time dropped from days to minutes",
    summary:
      "A skincare brand was spending too much time and budget on traditional product photography. We built an internal tool using the Gemini API — upload a raw photo, type a prompt, and get studio-quality marketing images in seconds.",
    details: ["Prompt-to-image pipeline", "Marketing cost reduction", "On-demand visuals"],
    hasCaseStudy: false,
  },
  {
    slug: "ai-video-generator",
    name: "AI Video Generator",
    category: "Internal Tool",
    tags: ["AI Tool", "Internal Tool", "Video"],
    accent: "#ff5ec4",
    meta: "AI video rendering / Veo model / multi-format output",
    outcome: "Dynamic video content on demand, no external crew needed",
    summary:
      "The same brand needed scalable video content without expensive production cycles. We built a companion tool using Gemini's Veo model — feed it a product image and a prompt, and it renders polished videos in multiple aspect ratios.",
    details: ["Product-to-video pipeline", "Multiple aspect ratios", "Zero production overhead"],
    hasCaseStudy: false,
  },
  // Jugni Lifestyle moved to last position
  {
    slug: "jugni-lifestyle",
    name: "Jugni Lifestyle",
    category: "E-commerce",
    tags: ["Shopify", "AI"],
    accent: "#a78bfa",
    meta: "Shopify storefront / AI visuals / launch growth",
    outcome: "Weekly orders became consistent",
    summary:
      "They needed an online home. We crafted a conversion-first Shopify experience with AI-assisted image production and a cleaner buying flow.",
    details: ["Store redesign", "AI image pipeline", "Checkout uplift"],
    hasCaseStudy: true,
    caseStudy: {
      hero:
        "A lifestyle brand needed an online home that converts. We built a conversion-first Shopify storefront with an AI-assisted image pipeline and a cleaner buying flow.",
      challenge:
        "The brand had a strong product story but no consistent way to bring it online. Photography was a bottleneck, and the storefront wasn't shaped around buying intent.",
      approach:
        "We redesigned the Shopify experience around the buyer's path, set up an AI-assisted product image pipeline to remove the photography bottleneck, and tightened checkout to reduce drop-off.",
      results: [
        { metric: "Consistent orders", desc: "Weekly orders became predictable" },
        { metric: "Faster visuals", desc: "AI pipeline cut image production from days to hours" },
        { metric: "Cleaner checkout", desc: "Fewer drop-offs at the final step" },
      ],
      services: ["Shopify", "AI image pipeline", "Conversion design", "Launch growth"],
    },
  },
];
